import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

import './Auth.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  // Local demo users for email quick-fill (not for actual login)
  const demoUsers = [
    { name: 'Owner', email: 'owner@yourcompany.com', role: 'owner' },
    { name: 'Project Manager', email: 'pm@yourcompany.com', role: 'project_manager' },
    { name: 'HR Manager', email: 'hr@yourcompany.com', role: 'hr' },
    { name: 'Employee', email: 'employee@yourcompany.com', role: 'employee' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await login(email, password);
    } catch (error) {
      console.error('Login failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDemoLogin = (demoEmail) => {
    setEmail(demoEmail);
    setPassword(''); // Clear password - user must enter their real password
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="company-logo">
            <i className="fas fa-building"></i>
            <h1>Versai Tech Solutions</h1>
          </div>
          <p className="login-subtitle">HR Management Portal</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email" className="form-label">Email</label>
            <input
              type="email"
              id="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              type="password"
              id="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary btn-full-width"
            disabled={loading}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                Signing In...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>

        
      </div>
    </div>
  );
};

export default Login;
